import AxiosInstance from "@/core/services/axios.service";

// Action Types
export const GET_LEAD = "getLead";
export const UPDATE_LEAD = "updateLead";
export const CREATE_LEAD = "createLead";
export const DELETE_LEAD = "removeLead";
export const UPDATE_LEAD_AGENT = "updateLeadAgent";
export const UPDATE_LEAD_STATUS = "updateLeadStatus";
export const UPDATE_LEADS_NOTES_COUNT = "updateLeadsNotesCount";
export const NOT_REACHED = "notReached";
export const REACHED = "reached";

// Mutations Types
const SET_LEAD = "setLead";
const EDIT_LEAD = "editLead";
const EDIT_LEAD_STATUS = "editLeadStatus";
const EDIT_LEADS_NOTES_COUNT = "editLeadsNotesCount";
const EDIT_LEAD_AGENT = "editLeadAgent";

const state = {
  lead: {},
  leadStatus: [],
};

const getters = {
  getCurrentLead(state) {
    return state.lead;
  },
  leadStatus(state) {
    return state.leadStatus;
  },
};

const actions = {
  [GET_LEAD]({ commit }, id) {
    return AxiosInstance.get(`leads/${id}`).then(({ data }) => {
      commit(SET_LEAD, data);
      return data;
    });
  },
  [UPDATE_LEAD]({ commit }, payload) {
    return AxiosInstance.put(`leads/${payload.id}`, payload).then(
      ({ data }) => {
        commit(EDIT_LEAD, data);
        return data;
      }
    );
  },
  [DELETE_LEAD](_, item) {
    return AxiosInstance.delete(`leads/${item.id}`);
  },
  [CREATE_LEAD](_, payload) {
    return AxiosInstance.post("leads", payload);
  },
  [UPDATE_LEAD_AGENT]({ commit }, { id, agent_id }) {
    return AxiosInstance.patch(`leads/${id}/agent`, { agent_id }).then(
      ({ data }) => {
        commit(EDIT_LEAD_AGENT, { payload: data });
        return data;
      }
    );
  },
  [UPDATE_LEAD_STATUS]({ commit }, { id, status }) {
    return AxiosInstance.patch(`leads/${id}/status`, { status }).then(
      ({ data }) => {
        commit(EDIT_LEAD_STATUS, { status: data });
        return data;
      }
    );
  },
  [UPDATE_LEADS_NOTES_COUNT]({ commit }, { note_type }) {
    commit(EDIT_LEADS_NOTES_COUNT, { note_type });
  },
  [NOT_REACHED]({ commit }, { id }) {
    return AxiosInstance.post(`leads/${id}/not_reached`).then(({ data }) => {
      commit(EDIT_LEAD_STATUS, { status: data });
      return data;
    });
  },
  [REACHED]({ commit }, { id }) {
    return AxiosInstance.post(`leads/${id}/reached`).then(({ data }) => {
      commit(EDIT_LEAD_STATUS, { status: data });
      return data;
    });
  },
};

const mutations = {
  [SET_LEAD](state, lead) {
    state.lead = lead;
  },
  [EDIT_LEAD](state, payload) {
    state.lead = payload;
  },
  [EDIT_LEAD_AGENT](state, { payload }) {
    const availableStatus = [1, 2];
    const status = availableStatus.includes(payload.status)
      ? 6
      : payload.status;
    payload.status = status;
    state.lead = payload;
  },
  [EDIT_LEAD_STATUS](state, { status }) {
    state.lead.status = status;
  },
  [EDIT_LEADS_NOTES_COUNT](state, { note_type }) {
    if (note_type === "note") {
      state.lead.notes_count++;
    } else {
      state.lead.call_records_count++;
    }
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
